export const getQueryParam = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};

export const capitalizeFirstLetter = (str) => {
  if (typeof str !== "string" || str.length === 0) {
    return str; // Handle empty or non-string inputs
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const handlerStrongPass = (password) => {
  const strongPassPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  return strongPassPattern.test(password);
};

/**
 * XHRInterceptor
 * Allows you to hook into all XMLHttpRequests globally.
 * Now supports multiple listeners.
 */
export const XHRInterceptor = (() => {
  let originalOpen = null;
  let originalSend = null;

  const sendListeners = [];
  const completeListeners = [];

  function enable({ onSend, onComplete }) {
    // Register listeners — works even if already enabled
    if (typeof onSend === "function") sendListeners.push(onSend);
    if (typeof onComplete === "function") completeListeners.push(onComplete);

    // If already hooked, no need to wrap again
    if (originalOpen || originalSend) {
      return;
    }

    originalOpen = window.XMLHttpRequest.prototype.open;
    originalSend = window.XMLHttpRequest.prototype.send;

    // Wrap open()
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this._method = method;
      this._url = url;
      return originalOpen.apply(this, arguments);
    };

    // Wrap send()
    window.XMLHttpRequest.prototype.send = function (data) {
      let shouldSend = true;

      // Notify all listeners
      sendListeners.forEach((listener) => {
        try {
          const result = listener({
            method: this._method,
            url: this._url,
            data,
            xhr: this,
            abort: () => {
              shouldSend = false;
              try {
                this.abort();
              } catch (_) {
                console.error("XHRInterceptor Aborted");
              }
            },
          });

          // Any listener returning false aborts the request
          if (result === false) {
            shouldSend = false;
            this.abort();
          }
        } catch (err) {
          console.error("XHRInterceptor onSend error:", err);
        }
      });

      // If aborted, skip sending
      if (!shouldSend) {
        console.warn("❌ XHR request aborted by interceptor:", this._url);
        return;
      }

      // Install onreadystatechange
      const originalReadyState = this.onreadystatechange;
      this.onreadystatechange = function () {
        if (this.readyState === 4) {
          completeListeners.forEach((listener) => {
            try {
              listener({
                method: this._method,
                url: this._url,
                status: this.status,
                response: this.responseText,
                xhr: this,
              });
            } catch (err) {
              console.error("XHRInterceptor onComplete error:", err);
            }
          });
        }

        if (originalReadyState) {
          return originalReadyState.apply(this, arguments);
        }
      };

      return originalSend.apply(this, arguments);
    };

    console.log("✅ XHRInterceptor enabled");
  }

  function disable() {
    if (originalOpen && originalSend) {
      window.XMLHttpRequest.prototype.open = originalOpen;
      window.XMLHttpRequest.prototype.send = originalSend;
      originalOpen = originalSend = null;

      sendListeners.length = 0;
      completeListeners.length = 0;

      console.log("🛑 XHRInterceptor disabled");
    }
  }

  return { enable, disable };
})();

export const parseFormData = (data) => {
  if (!data || typeof data !== "string") return data;
  const params = new URLSearchParams(data);
  const obj = {};
  for (const [key, value] of params.entries()) {
    obj[key] = value;
  }
  return obj;
};
